import { render, staticRenderFns } from "./pbi-network-simulator-auto.page.vue?vue&type=template&id=96e4a7d8"
import script from "./pbi-network-simulator-auto.page.vue?vue&type=script&lang=ts"
export * from "./pbi-network-simulator-auto.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports